export const isDevelopment = process.env.NODE_ENV !== 'production';

export const isDevelopmentReact = process.env.REACT_APP_STAGE !== 'production';

export const logDevelopmentError = (error: Error): void => {
  if (isDevelopment) console.log(error);
};
